import { render, staticRenderFns } from "./CorreosChileComponent.vue?vue&type=template&id=1efdfe17&"
import script from "./CorreosChileComponent.vue?vue&type=script&lang=js&"
export * from "./CorreosChileComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports